import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import FilterNoneOutlinedIcon from '@material-ui/icons/FilterNoneOutlined';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Modal, { ModalProps } from '../Modal';
import ModalTitle from '../ModalTitle';
import { Trans, useTranslation } from 'react-i18next';
import { useWeb3React } from '@web3-react/core';
import useConnectWallet from 'hooks/useConnectWallet';

const MyWalletModal: React.FC<ModalProps> = ({ onDismiss }) => {
  const [copy, setCopy] = useState(false);

  const { account } = useWeb3React();
  const wallet = useConnectWallet();

  const { t } = useTranslation();

  const handleClickAddress = () => {
    window.open(`https://bscscan.com/address/${account}`);
  };

  const handleCopyAddress = () => {
    setCopy(true);
    setTimeout(() => {
      setCopy(false);
    }, 1000);
  };

  const handleLogout = useCallback(async () => {
    wallet.logout();
    onDismiss();
  }, [onDismiss]);

  return (
    <Modal onDismiss={onDismiss}>
      <ModalTitle>
        <Trans>Your wallet</Trans>
      </ModalTitle>
      <StyledAddress>{account}</StyledAddress>
      <StyledRowLink>
        <StyledLinkContainer onClick={handleClickAddress}>
          <StyledLink>
            <Trans>View on BscScan</Trans>
          </StyledLink>
          <OpenInNewIcon style={{ fontSize: 14, fontWeight: 500 }} />
        </StyledLinkContainer>

        <StyledSpacer />

        <StyledLinkContainer onClick={handleCopyAddress}>
          <StyledLink>{copy ? t(`Copied!`) : t(`Copy Address`)}</StyledLink>
          <CopyToClipboard text={account} onCopy={() => setCopy(true)}>
            <FilterNoneOutlinedIcon style={{ fontSize: 14, fontWeight: 500 }} />
          </CopyToClipboard>
        </StyledLinkContainer>
      </StyledRowLink>
      <StyledWrapper>
        <StyledLogoutBtn onClick={handleLogout}>
          <Trans>Logout</Trans>
        </StyledLogoutBtn>
      </StyledWrapper>
    </Modal>
  );
};

const StyledAddress = styled.div`
  color: ${(props) => props.theme.color.grey[300]};
  font-size: 18px;
  font-weight: bold;
  @media (max-width: 425px) {
    margin-left: 12px;
    margin-right: 12px;
    white-space: nowrap;
    overflow: hidden;
    font-size: 14px;
    max-width: 425px;
  }

  @media (max-width: 320px) {
    font-size: 12px;
    max-width: 320px;
  }
`;

const StyledRowLink = styled.div`
  display: flex;
  flex-direction: row;
  font-weight: normal;
  margin-top: 6px;
  @media (max-width: 425px) {
    margin-left: 12px;
  }
`;

const StyledLink = styled.div`
  color: ${(props) => props.theme.color.yellow[100]};
  font-size: 14px;
  font-weight: normal;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledLinkContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;

  svg {
    color: ${(props) => props.theme.color.yellow[100]};
    margin-left: 4px;
  }
`;

const StyledSpacer = styled.div`
  width: 26px;
`;

const StyledWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;

const StyledLogoutBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background-color: ${(props) => props.theme.color.purple[100]};
  outline: none;
  border: 0;
  cursor: pointer;
  margin-top: 20px;
  padding: 12px 36px;
  font-size: 14px;
  font-weight: bold;
  color: #fff;
`;

export default MyWalletModal;
